import Vue from 'vue';

const state = {
  itemAgropecuario: null,
  safra: null,
  banco: null,
  status: null,
  cooperado: null,
  tipoProjeto: null,
};

const mutations = {
  SET_FILTRO_COMPLETO(state, filtro) {
    Object.keys(filtro).forEach(key => {
      Vue.set(state, key, filtro[key]);
    });
  },
  LIMPAR_FILTROS(state) {
    Object.keys(state).forEach(key => {
      Vue.set(state, key, null);
    });
  },
};

const getters = {
  filtroCompleto: (state) => ({ ...state }),
};

const actions = {
  setFiltroCompleto({ commit }, filtro) {
    commit('SET_FILTRO_COMPLETO', filtro);
  },
  limparFiltros({ commit }) {
    commit('LIMPAR_FILTROS');
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
